import { usePermissions } from "./usePermissions";

// Conditional render based on permission.
// <Can module="schools" action="delete"><button>حذف</button></Can>
export default function Can({ module, action = "view", children, fallback = null }) {
  const { can } = usePermissions();
  return can(module, action) ? <>{children}</> : <>{fallback}</>;
}
